import { z } from 'zod';

/**
 * URL search で配列フィルタを正規化する。
 *
 * jsurl2 経由では配列になるが、素の query string（`?key=id`）や
 * TanStack Router の JSON.parse 由来の `null` では string / null になる。
 */
export const optionalStringArraySearchSchema = z.union([z.array(z.string()), z.string().transform(val => val ? [val] : []), z.null().transform(() => [])]).transform(arr => {
  const filtered = arr.filter(val => val !== '');
  return filtered.length === 0 ? undefined : filtered;
}).optional();